import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_PLAYERS_QUERY_KEY } from '@/state/queries/players/use-get-players';
import type { PlayerDto } from '@/types/dtos/player/response/player.dto';

export const useUpdatePlayerNameMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ playerId, name }: { playerId: string; name: string }) => {
      const token = await getToken();
      return updatePlayerName(playerId, name, token ?? '');
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [GET_PLAYERS_QUERY_KEY],
      });
    },
  });
};

const updatePlayerName = async (playerId: string, name: string, token: string): Promise<PlayerDto> => {
  const url = `${import.meta.env.VITE_API_URL}/player/${playerId}/name`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body: { name }, token });
};
